import React, { useEffect } from 'react';

import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
export const EEMSDashboard = () => {
  var eeemsDBJsonArr = [
    {
      fieldName: 'ID',
      description:
        'Internal file identifier. Not applicable for near real time transactions  ',
    },

    {
      fieldName: 'Customer Name',
      description: 'Customer Name associated with the file submission ',
    },
    {
      fieldName: 'Received',
      description:
        'Date and time the file was received. Date only is displayed for near real time transactions.   ',
    },
    {
      fieldName: 'Status',
    },
  ];

  var statusCodeJsonArr = [
    {
      statusCode: 'Cancelled',
      explantion:
        'The transaction set has been cancelled and no updates were applied to the eligibility system. If action is required by you, your Electronic Eligibility Analyst will contact you.',
    },
    {
      statusCode: 'Complete',
      explantion:
        'Transaction Set has been processed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'Completed With Warnings',
      explantion:
        'Transaction Set has been processed, but with low severity errors (warnings) detected on some records.  All records have been updated to the Electronic Eligibility Management System, however  those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'Completed with Errors',
      explantion:
        'Transaction Set has been processed, but with errors detected on some records. Those records not in error have been updated to the eligibility system, error records are pended in the Electronic Eligibility Management System process until resolved by the Electronic Eligibility Analyst assigned to the submission group or corrected by a new file submission from the customer.',
    },
    {
      statusCode: 'CMPL REPR ALL',
      explantion:
        'Transaction Set has been reprocessed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'CMPL REPR ALL WITH WRN',
      explantion:
        'Transaction Set has been reprocessed, but with low severity errors (warnings) detected on some records.  All records have been updated to the Electronic Eligibility Management System, however those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'CMPL REPR ALL WITH ERR',
      explantion:
        'Transaction Set has been reprocessed, but with errors detected on some records. Those records not in error have been updated to the Electronic Eligibility Management System, error records are pended in the Electronic Eligibility Management System process until resolved by the Electronic Eligibility Analyst assigned to the submission group or corrected by a new file submission from the customer.',
    },
    {
      statusCode: 'CMPL REPR PART',
      explantion:
        'Some transactions within this transaction set have been reprocessed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'CMPL REPR PART WITH WRN',
      explantion:
        'Some transactions within this transaction set have been reprocessed, but with low severity errors (warnings) detected on some records.  All records have been updated to the Electronic Eligibility Management System, however those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'CMPL REPR PART WITH ERR',
      explantion:
        'Some transactions within this transaction Set have been reprocessed, but with errors detected on some records. Those records not in error have been updated to the Electronic Eligibility Management System, error records are pended in the Electronic Eligibility Management System process until resolved by the Electronic Eligibility Analyst assigned to the submission group or corrected by a new file submission from the customer.',
    },
    {
      statusCode: 'Failed',
      explantion:
        'The file failed during processing. If action is required by you, your Electronic Eligibility Analyst will contact you.',
    },
    {
      statusCode: 'Processed',
      explantion:
        'Transaction Set has been processed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'Processed with Errors',
      explantion:
        'Transaction Set has been processed, but with errors detected on some records. Those records not in error have been updated to the eligibility system, error records are pended in the Electronic Eligibility Management System process until resolved by the Electronic Eligibility Analyst assigned to the submission group or corrected by a new file submission from the customer.',
    },
    {
      statusCode: 'Processed with Warnings',
      explantion:
        'Transaction Set has been processed, but with low severity errors (warnings) detected on some records. All records have been updated to the Electronic Eligibility Management System; however those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'Processing',
      explantion:
        'The file is processing. Files with a processing status may Complete, Fail, or Exceed Thresholds.',
    },
    {
      statusCode: 'Reprocessing',
      explantion:
        'Some or the entire file is reprocessing. Processing reports are not accessible during reprocessing',
    },
    {
      statusCode: 'Reprocessing Failed',
      explantion:
        'The file failed during reprocessing. If action is required by you, your Electronic Eligibility Analyst will contact you.',
    },
    {
      statusCode: 'REPR THRESH XCD',
      explantion:
        'Threshold violations were encountered during re-processing.  Entire transaction set is in error on  the Electronic Eligibility Management System until researched and corrected by the Electronic Eligibility Analyst assigned to the submission group.',
    },
    {
      statusCode: 'Results Available',
      explantion:
        'The transaction set has been processed and the results are available for review.',
    },
    {
      statusCode: 'Thresholds Exceeded',
      explantion:
        'Threshold violations were encountered during processing. Entire transaction set is in error on the Electronic Eligibility Management System until researched and corrected by the Electronic Eligibility Analyst assigned to the submission group. If action is required by you, your Electronic Eligibility Analyst will contact you.',
    },
  ];

  return (
    <>
      <p>
        The Electronic Eligibility Management System Dashboard lists all of the
        files and the corresponding statuses of the files. Only the customer
        names correlating with the User ID and Password entered at logon are
        displayed.
      </p>
      <br />
      <p>
        If your Customer Name is not appearing on the dashboard and you are
        currently sending an electronic eligibility file for this customer to
        the Electronic Eligibility Management System, please contact your
        Electronic Eligibility Analyst for assistance in getting access to your
        processing results.
      </p>
      <br />
      <p>
        You may page through the files on the dashboard by clicking on the
        navigation arrows beneath the display. The dashboard may be sorted by
        ID, Customer Name, Received date, or Status by clicking on the header of
        the column to be sorted.
      </p>
      <br />
      <p>
        The dashboard displays the most current status when the page is
        refreshed. To refresh the page, click the refresh button on the toolbar
        or navigate to the View menu and select Refresh.
      </p>
      <br />
      <p>
        Electronic Eligibility Management System reports for a file run may be
        accessed by clicking on the reports link corresponding to the Customer
        Name and Received date. The Processing Statistics for the corresponding
        file run will be displayed. From the Processing Statistics page, you may
        navigate to the error and transaction reports. Reports are available for
        files with a Complete, Processed, Thresholds Exceeded or Results
        Available status.
      </p>

      <Table.Container title="Manual Static Table">
        <Table.TableHeader>
          <Table.TableHeaderRow>
            <Table.Column>Field</Table.Column>
            <Table.Column>Field Description</Table.Column>
          </Table.TableHeaderRow>
        </Table.TableHeader>
        {eeemsDBJsonArr.map((item) => (
          <Table.TableBody>
            {!(item.fieldName == 'Status') && (
              <Table.Row>
                <Table.Cell>{item.fieldName}</Table.Cell>
                <Table.Cell>{item.description}</Table.Cell>
              </Table.Row>
            )}
            {item.fieldName === 'Status' && (
              <Table.Row>
                <Table.Cell>Processing Status</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Status Code</Table.Column>
                        <Table.Column>Description</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {statusCodeJsonArr.map((item2) => (
                        <Table.Row>
                          <Table.Cell>{item2.statusCode}</Table.Cell>
                          <Table.Cell>{item2.explantion}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.TableBody>
        ))}
      </Table.Container>
    </>
  );
};
